// Radar Config - Technology Radar section definitions

/**
 * The three Technology Radar sections, each representing a curated analysis story.
 * accentColor is used for section-specific visual theming throughout the radar UI.
 */
export const RADAR_SECTIONS = [
  {
    id: 'chemistry-evolution',
    title: 'Chemistry Evolution',
    teaserQuestion: 'How has cell chemistry evolved over the past decade?',
    description:
      "From NMC dominance to the rise of LFP and silicon anodes — trace the material evolution driving today's cells.",
    plotCount: 3,
    accentColor: '#ea5b0c',
    route: '/radar/chemistry-evolution',
  },
  {
    id: 'performance-limits',
    title: 'Performance Limits',
    teaserQuestion: 'Where is the industry energy-power frontier today?',
    description:
      'Explore the Ragone boundary and track how performance envelopes have expanded year by year.',
    plotCount: 3,
    accentColor: '#0d7c99',
    route: '/radar/performance-limits',
  },
  {
    id: 'naion-vs-lfp',
    title: 'Na-Ion vs LFP',
    teaserQuestion: 'Can sodium-ion technology close the gap with lithium iron phosphate?',
    description:
      'A direct comparison of energy density, power, and efficiency trajectories between two leading chemistries.',
    plotCount: 2,
    accentColor: '#16a34a',
    route: '/radar/naion-vs-lfp',
  },
]

/**
 * Lookup map for O(1) section access by id.
 */
export const SECTION_BY_ID = Object.fromEntries(RADAR_SECTIONS.map((s) => [s.id, s]))
